import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { searchApiRef } from '@backstage/plugin-search-react';
import searchPlugin from '@backstage/plugin-search/alpha';
import { DeduplicatingSearchApi } from '../apis/DeduplicatingSearchApi';

export const searchModule = createFrontendModule({
  pluginId: searchPlugin.pluginId,
  extensions: [
    // ── API (→ global API registry) ─────────────────────────
    ApiBlueprint.make({
      name: 'custom-search',
      params: defineParams =>
        defineParams(
          createApiFactory({
            api: searchApiRef,
            deps: {
              discoveryApi: discoveryApiRef,
              fetchApi: fetchApiRef,
            },
            factory: ({ discoveryApi, fetchApi }) =>
              new DeduplicatingSearchApi(discoveryApi, fetchApi),
          }),
        ),
    }),

    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/search',
        noHeader: true,
        routeRef: searchPlugin.routes.root,
        loader: () =>
          import('../components/search/SearchPage').then(m => (
            <m.SearchPageRoot />
          )),
      },
    }),
  ],
});
